import { branch, renderComponent } from 'recompose'

import NotFound from '../screens/NotFound'

const withNotFoundWhenEmpty = queryName =>
  branch(props => props.data[queryName] === null, renderComponent(NotFound))

export default withNotFoundWhenEmpty



// WEBPACK FOOTER //
// ./src/hocs/withNotFoundWhenEmpty.js